import { useMemo } from "react";
import { AbstractDate } from "@linkfluence/models/date";
import { getRangeFromDates } from "@tootools/date";
import { getDateFromClause } from "@radarly/models/clause/getter";
import { getTimezoneFromFragment } from "@radarly/models/fragment";
import { AIFragment, SearchFragment } from "@radarly/models/search";
import { usePrevious } from "./usePrevious";

export function useRangeFromFragment<F extends SearchFragment | AIFragment>(
  fragment: F,
  loading: boolean,
  nowDate?: AbstractDate
) {
  const timezone = getTimezoneFromFragment(fragment);
  const range = useMemo(() => {
    const { from, to } = getDateFromClause(fragment.request.query);
    return getRangeFromDates(from, to, timezone, nowDate);
  }, [fragment.request.query, timezone, nowDate]);
  return usePrevious(range, loading);
}
